
<div class="col-md-12 mt-5">
  <form [formGroup]="auditForm" (ngSubmit)="onSubmit()">
    Thank you for visiting the Deficiency Portal for the Canoga Park Class Action Settlement.<br /><br />

    <ng-container *ngIf="requireDoc">
      Our records indicate that additional information is needed before your claim can be approved. The documentation submitted
      with your claim did not sufficiently establish eligibility.<br /><br />

      To cure this deficiency, please provide documentation demonstrating that you owned the property as of July 1, 2024, or as
      of August 11, 2026, the date of the Notice of Class Action Settlement.<br /><br />

      Please upload a copy of one of the acceptable documents listed below and check the box that corresponds to the document you
      are submitting.<br /><br />
    </ng-container>

    <ng-container *ngIf="requireTin">
      Our records indicate that additional information is needed before your claim can be approved. Your claim did not include a
      complete Social Security Number (SSN) or Tax Identification Number (TIN), either of which are required for tax purposes.<br /><br />

      To cure this deficiency, please select whether you will be providing a Social Security Number (SSN) or a Tax Identification
      Number (TIN). Once a selection has been made, an entry box will appear where you can provide the complete corresponding
      number.<br /><br />
    </ng-container>

    <div class="row rowformat" *ngIf="requireDoc">
      <div class="col-md-6">
        <div class="form-group">
          <label class="labelBoldWeight" for="documentType">Documentation Type:<span style="color:red" class="required"> *</span></label>
          <select class="form-control" formControlName="documentType" (change)="getClaimantAccounTypeValue($event)" [ngClass]="{ 'is-invalid': f.documentType.errors }">
            <option value="">Please Select an Option</option>
            <option value="Property deed">Property deed</option>
            <option value="Title insurance policy">Title insurance policy</option>
            <option value="Mortgage statement">Mortgage statement</option>
            <option value="Property tax statement or bill">Property tax statement or bill</option>
            <option value="Settlement or closing statement">Settlement / closing statement (e.g., HUD-1, Closing Disclosure)</option>
            <option value="Homeowners insurance policy declaration page">Homeowners insurance policy declaration page</option>
            <option value="Certificate of title">Certificate of title</option>
            <option value="Government record evidencing ownership">Government record evidencing ownership</option>
            <option value="Utility bill">Utility bill (water, electric, gas, sewer, or trash) listing the Settlement Class Member’s name and the address of the property in the Class Area</option>
            <option value="Other">Other (please describe)</option>
          </select>
          <div *ngIf="f.documentType.errors" class="invalid-feedback">
            <div *ngIf="f.documentType.errors.required">This field is required</div>
          </div>
        </div>
      </div>
      <div class="col-md-6" *ngIf="showDivOtherDocumentType">
        <div class="form-group">
          <label class="labelBoldWeight" for="otherDocumentType">Other (please describe):<span style="color:red" class="required"> *</span></label>
          <input type="text" class="form-control" formControlName="otherDocumentType" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.otherDocumentType.errors }" />
          <div *ngIf="f.otherDocumentType.errors" class="invalid-feedback">
            <div *ngIf="f.otherDocumentType.errors.required">This field is required</div>
            <div *ngIf="f.otherDocumentType.errors.minlength">This field must be at least 2 characters</div>
            <div *ngIf="f.otherDocumentType.errors.maxlength">This field must not be greater than 50 characters</div>
            <div *ngIf="f.otherDocumentType.errors.pattern">
              Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row rowformat">
      <div class="col-md-6">
        <div class="form-group">
          <label class="labelBoldWeight" for="emailAddress">Email Address:<span style="color:red" class="required"> *</span></label>
          <input type="text" class="form-control" formControlName="emailAddress" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.emailAddress.errors }" />
          <div *ngIf="f.emailAddress.errors" class="invalid-feedback">
            <div *ngIf="f.emailAddress.errors.required">This field is required</div>
            <div *ngIf="f.emailAddress.errors.maxlength">This field must not be greater than 255 characters</div>
            <div *ngIf="f.emailAddress.errors.pattern">This is not a valid email address</div>
          </div>
        </div>
      </div>
    </div>
    <div class="row rowformat" *ngIf="requireTin">
      <div class="col-md-6">
        <span class="labelBoldWeight">Select an Option Below:<span style="color:red" class="required"> *</span></span><br />
        <input type="radio" id="lastFourOfSSN" formControlName="optTINSSN" (change)="getOptTINSSNValue($event)" value="Last Four Of SSN">&nbsp;
        <label for="lastFourOfSSN">Social Security Number</label>
        &nbsp;
        <input type="radio" id="taxIdentificationNumber" formControlName="optTINSSN" (change)="getOptTINSSNValue($event)" value="Tax Identification Number">&nbsp;
        <label for="taxIdentificationNumber"> Tax Identification Number</label>
        <div *ngIf="f.optTINSSN.errors" class="custom-error-original">
          <div *ngIf="f.optTINSSN.errors.required">This field is required</div>
        </div>
      </div>
    </div>
    <div class="row rowformat" *ngIf="requireTin">
      <div class="col-md-6">
        <div class="form-group" *ngIf="showDivlast4SSN">
          <label class="labelBoldWeight" for="sSN">Social Security Number:<span style="color:red" class="required"> *</span></label>
          <input type="text" mask="XXX-XX-0000" class="form-control" [hiddenInput]="true" formControlName="sSN" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.sSN.errors }" />
          <div *ngIf="f.sSN.errors" class="invalid-feedback">
            <div *ngIf="f.sSN.errors.required">This field is required</div>
            <div *ngIf="f.sSN.errors.minlength">This field must be at least 9 digits</div>
            <div *ngIf="f.sSN.errors.maxlength">This field must not be greater than 9 digits</div>
            <div *ngIf="f.sSN.errors.pattern">
              Only use letters numbers
            </div>
          </div>
        </div>
        <div class="form-group" *ngIf="showDivTIN">
          <label class="labelBoldWeight" for="tin">Tax Identification Number:<span style="color:red" class="required"> *</span></label>
          <input type="text" mask="000000000" class="form-control" formControlName="tin" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.tin.errors }" />
          <div *ngIf="f.tin.errors" class="invalid-feedback">
            <div *ngIf="f.tin.errors.required">This field is required</div>
            <div *ngIf="f.tin.errors.minlength">This field must be at least 9 digits</div>
            <div *ngIf="f.tin.errors.maxlength">This field must not be greater than 9 digits</div>
            <div *ngIf="f.tin.errors.pattern">
              Only use letters numbers
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <br />
    <div class="row mt-4" *ngIf="requireDoc">
      <div class="col-md-12">
        <input type="file" id="file" #fileInput (change)="getFileDetails($event)" multiple class="form-control form-control-sm hidden" />
        <label for="file" class="btn btn-primary btn-sm">Select files</label>
        <br />
      </div>
    </div>
    <div class="row" *ngIf="requireDoc">
      <div class="col-sm-12">
        <table class="table" #listofFiles>
          <thead>
            <tr>
              <th class="hidden">Id</th>
              <th>Files To Be Uploaded</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let sd of supportingDocuments; let i = index">
              <td class="hidden">{{i}}</td>
              <td>{{sd.name}}</td>
              <td>
                <button type="button" class="btn btn-danger" (click)="removeRow(i)">Remove</button>
              </td>
            </tr>
          </tbody>
        </table>
        <div *ngIf="showDivFileUploadMessage == true" style="color:red; font-size:1.1em; font-weight:bold">
          You must upload the required documents to submit.
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-12">
        Proof of ownership will be subject to verification by the Class Administrator.
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <re-captcha formControlName="googleRecaptchaToken" (resolved)="resolved($event)" [ngClass]="{ 'is-invalid': submitted && f.googleRecaptchaToken.errors }"></re-captcha>
          <div *ngIf="submitted && f.googleRecaptchaToken.errors" class="invalid-feedback">
            <div *ngIf="f.googleRecaptchaToken.errors.required" style="color:red; font-size:80%">This field is required</div>
          </div>
          <!--<div style="color:#dc3545; font-size:80%; font-weight:bold">This field is required*</div>-->

        </div>
      </div>
    </div>
    <br />
    <!--<div class="row rowformat">
    <div class="col-md-12">
      <div class="form-group">
        <label for="signature"><b>Signature of Claimant:</b><span style="color:red" class="required"> *</span></label>
        <input type="text" class="form-control" id="signature" formControlName="signature" autocomplete="no"
               trim="blur" [ngClass]="{ 'is-invalid': f.signature.errors }" />
        <div *ngIf="f.signature.errors" class="invalid-feedback">
          <div *ngIf="f.signature.errors.required">This field is required</div>
          <div *ngIf="f.signature.errors.maxlength">This field must not be at greater 50 characters</div>
          <div *ngIf="f.signature.errors.minlength">This field must be at least 2 characters</div>
          <div *ngIf="f.signature.errors.pattern">
            Only use letters, numbers, periods, spaces, hyphens,
            brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
          </div>
        </div>
      </div>
    </div>
  </div>-->
    <ul class="list-inline text-center">
      <li><button type="submit" class="btn btn-primary" [disabled]="clicked">SUBMIT</button></li>
    </ul>
  </form>
  <ngx-spinner bdColor="rgba(51,51,51,0.8)"
               size="medium"
               color="#fff"
               type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
  </ngx-spinner>
</div>


